import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FileVersion } from './file.model';
import { QueryParams, QueryResult } from 'src/app/modules/core/store/models/query.model';
import { HttpService } from 'src/app/modules/core/services/http.service';

import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';

@Injectable({
  providedIn: 'root'
})
export class FileApiService {
  constructor(private http: HttpService) {}

  public getFiles(datasetUId, folderPath, params: QueryParams): Observable<QueryResult<FileVersion>> {
    if (!folderPath || folderPath === '/') {
      folderPath = '';
    }

    const queryString = this.http.queryStringFromObject(params);

    const url = `${apiBaseUrl}/v1/data/datasets/${datasetUId}/files/${folderPath}?${queryString}`;

    return this.http.get<QueryResult<FileVersion>>(url);
  }

  public deleteFile(datasetUId: string, file: FileVersion): Observable<void> {
    let fullFilePath = `${file.filePath}/${file.fileName}`;
    const segments = fullFilePath.split('/');
    fullFilePath = segments.map(s => encodeURIComponent(s)).join('/');
    const url = `${apiBaseUrl}/v1/data/datasets/${datasetUId}/files/${fullFilePath}`;

    return this.http.delete(url);
  }
}
